"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertJobInboxItemResponseSchema = exports.convertJobInboxItemRequestSchema = exports.updateJobInboxStatusRequestSchema = exports.assignJobInboxItemRequestSchema = exports.jobInboxListResponseSchema = exports.jobInboxListQuerySchema = exports.jobInboxItemDetailSchema = exports.jobInboxActivitySchema = exports.jobInboxItemSchema = exports.jobInboxLinksSchema = exports.jobInboxAttributionSchema = exports.jobInboxServiceAddressSchema = exports.jobInboxContactSchema = exports.jobInboxActivityTypeSchema = exports.jobInboxStatusSchema = exports.jobInboxSourceSchema = exports.jobInboxItemIdSchema = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
const marketing_attribution_1 = require("./marketing-attribution");
exports.jobInboxItemIdSchema = zod_1.z.string().uuid();
exports.jobInboxSourceSchema = zod_1.z.enum([
    "ONLINE_BOOKING",
    "LEAD_FORM",
    "WEBSITE_CHAT",
    "GOOGLE_BUSINESS_PROFILE",
    "GOOGLE_LOCAL_SERVICES",
    "ANGI",
    "THUMBTACK",
    "ELOCAL",
    "API",
    "APP",
    "OTHER",
]);
exports.jobInboxStatusSchema = zod_1.z.enum([
    "NEW",
    "IN_REVIEW",
    "ACCEPTED",
    "DISMISSED",
    "SPAM",
    "CONVERTED",
]);
exports.jobInboxActivityTypeSchema = zod_1.z.enum([
    "RECEIVED",
    "VIEWED",
    "ASSIGNED",
    "STATUS_CHANGED",
    "CONVERTED",
    "LINKED",
]);
const jobInboxContactDetailsSchema = zod_1.z.object({
    firstName: zod_1.z.string().trim().min(1).max(80),
    lastName: zod_1.z.string().trim().min(1).max(80),
    companyName: zod_1.z.string().trim().max(160).nullable(),
    email: zod_1.z.string().trim().toLowerCase().email().max(320).nullable(),
    phone: zod_1.z.string().trim().min(1).max(32).nullable(),
});
exports.jobInboxContactSchema = jobInboxContactDetailsSchema.refine((value) => value.email || value.phone, {
    path: ["email"],
    message: "A contact email or phone number is required.",
});
exports.jobInboxServiceAddressSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(1).max(160),
    addressLine1: zod_1.z.string().trim().min(1).max(160),
    addressLine2: zod_1.z.string().trim().max(160).nullable(),
    city: zod_1.z.string().trim().min(1).max(120),
    state: zod_1.z.string().trim().min(2).max(80),
    postalCode: zod_1.z.string().trim().min(3).max(20),
    country: zod_1.z.string().trim().length(2),
    timezone: zod_1.z.string().trim().min(1).max(80).nullable(),
});
exports.jobInboxAttributionSchema = zod_1.z.object({
    channel: zod_1.z.string().trim().min(1).max(80),
    landingPath: zod_1.z.string().trim().max(2_048).nullable(),
    referrer: zod_1.z.string().trim().max(2_048).nullable(),
    utmSource: zod_1.z.string().trim().max(160).nullable(),
    utmMedium: zod_1.z.string().trim().max(160).nullable(),
    utmCampaign: zod_1.z.string().trim().max(160).nullable(),
    utmTerm: zod_1.z.string().trim().max(160).nullable(),
    utmContent: zod_1.z.string().trim().max(160).nullable(),
    gclid: zod_1.z.string().trim().max(200).nullable().optional(),
    gbraid: zod_1.z.string().trim().max(200).nullable().optional(),
    wbraid: zod_1.z.string().trim().max(200).nullable().optional(),
    firstTouch: marketing_attribution_1.marketingAttributionTouchSchema.nullable().optional(),
    lastTouch: marketing_attribution_1.marketingAttributionTouchSchema.nullable().optional(),
    adUserDataConsent: marketing_attribution_1.marketingAttributionConsentSchema.optional(),
});
exports.jobInboxLinksSchema = zod_1.z.object({
    leadId: zod_1.z.string().uuid().nullable(),
    customerId: zod_1.z.string().uuid().nullable(),
    serviceLocationId: zod_1.z.string().uuid().nullable(),
    jobId: zod_1.z.string().uuid().nullable(),
    estimateId: zod_1.z.string().uuid().nullable(),
    invoiceId: zod_1.z.string().uuid().nullable(),
    conversationId: zod_1.z.string().uuid().nullable(),
    bookingRequestId: zod_1.z.string().uuid().nullable(),
});
exports.jobInboxItemSchema = zod_1.z
    .object({
    id: exports.jobInboxItemIdSchema,
    businessId: zod_1.z.string().uuid(),
    source: exports.jobInboxSourceSchema,
    externalSourceId: zod_1.z.string().min(1).max(255),
    status: exports.jobInboxStatusSchema,
    title: zod_1.z.string().min(1).max(160),
    summary: zod_1.z.string().max(2_000).nullable(),
    contact: jobInboxContactDetailsSchema,
    serviceAddress: exports.jobInboxServiceAddressSchema.nullable(),
    attribution: exports.jobInboxAttributionSchema.nullable(),
    assignedToMembershipId: zod_1.z.string().uuid().nullable(),
    assignedToName: zod_1.z.string().nullable(),
    unreadCount: zod_1.z.number().int().nonnegative(),
    receivedAt: zod_1.z.string().datetime({ offset: true }),
    lastActivityAt: zod_1.z.string().datetime({ offset: true }),
    links: exports.jobInboxLinksSchema,
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
    convertedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    dismissedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
})
    .refine((item) => item.source === "WEBSITE_CHAT" ||
    item.contact.email ||
    item.contact.phone, {
    path: ["contact", "email"],
    message: "A contact email or phone number is required outside website chat.",
});
exports.jobInboxActivitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: exports.jobInboxActivityTypeSchema,
    actorMembershipId: zod_1.z.string().uuid().nullable(),
    title: zod_1.z.string().min(1).max(240),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
});
exports.jobInboxItemDetailSchema = exports.jobInboxItemSchema.safeExtend({
    safeMetadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    activities: zod_1.z.array(exports.jobInboxActivitySchema),
});
const queryBooleanSchema = zod_1.z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .optional();
exports.jobInboxListQuerySchema = pagination_1.paginationQuerySchema.extend({
    search: zod_1.z.string().trim().max(160).optional(),
    source: exports.jobInboxSourceSchema.optional(),
    status: exports.jobInboxStatusSchema.optional(),
    assignedToMembershipId: zod_1.z.string().uuid().optional(),
    unassigned: queryBooleanSchema,
    unread: queryBooleanSchema,
});
exports.jobInboxListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.jobInboxItemSchema),
    total: zod_1.z.number().int().nonnegative(),
    sourceCounts: zod_1.z.array(zod_1.z.object({
        source: exports.jobInboxSourceSchema,
        count: zod_1.z.number().int().nonnegative(),
    })),
    pageInfo: pagination_1.pageInfoSchema,
});
exports.assignJobInboxItemRequestSchema = zod_1.z.object({
    assignedToMembershipId: zod_1.z.string().uuid().nullable(),
});
exports.updateJobInboxStatusRequestSchema = zod_1.z.object({
    status: zod_1.z.enum(["IN_REVIEW", "ACCEPTED", "DISMISSED", "SPAM"]),
});
exports.convertJobInboxItemRequestSchema = zod_1.z.object({
    idempotencyKey: zod_1.z.string().uuid(),
    target: zod_1.z.enum(["LEAD", "JOB"]),
});
exports.convertJobInboxItemResponseSchema = zod_1.z.object({
    item: exports.jobInboxItemDetailSchema,
    target: zod_1.z.enum(["LEAD", "JOB"]),
    entityId: zod_1.z.string().uuid(),
    idempotentReplay: zod_1.z.boolean(),
});
//# sourceMappingURL=job-inbox.js.map